export const json2csv = (objArray, headers) => {
  const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
  let str = '';
  let line = '';

  if (!headers) {
    headers = Object.keys(array[0]).map(key => ({
      name: key,
      value: key,
    }));
  }

  headers.map((header) => {
    line += `"${header.replace(/"/g, '""')}",`;

    return null;
  });

  line = line.slice(0, -1);
  str += `${line}\r\n`;

  for (let i = 0; i < array.length; i += 1) {
    // eslint-disable-next-line no-shadow
    let line = '';

    headers.map((header) => {
      const value = `${array[i][header]}`;
      if (value) {
        line += `"${value.replace(/"/g, '""')}",`;
      } else {
        line += ',';
      }

      return null;
    });

    line = line.slice(0, -1);
    str += `${line}\r\n`;
  }

  return str;
};

export const downloadCsvFile = (data, fileName, type) => {
  const hiddenElement = document.createElement('a');
  hiddenElement.href = `data:${type};charset=utf-8,${encodeURI(data)}`;
  hiddenElement.target = '_blank';
  hiddenElement.download = fileName;
  hiddenElement.click();
};
